import React, { useEffect, useState } from 'react';
//import $ from 'jquery';
import UnidadeForm from './UnidadeForm';
import api from '../../../services/api';
import { X_FOWARD_HOST } from '../../../utils/env';

function Unidade() {
	const [unidades, setUnidades] = useState([]);
	const [contas, setContas] = useState([]);
	const [loading, setLoading] = useState(true);
	const [modalVisibleNova, setModalVisibleNova] = useState(false);
	//const [modalVisibleEdit, setModalVisibleEdit] = useState(false);
	// eslint-disable-next-line no-unused-vars
	const [unidade, setUnidade] = useState();
	//const [loadDelete, setLoadDelete] = useState(false);

	useEffect(() => {
		getContas();
		getUnidades();
		getCidades();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function getUnidades() {
		//var self = this;
		setLoading(true);
		//setState({ loading: true });

		const options = {
			headers: {
				'content-type': 'application/json',
				//'content-length': 89,
				'X-Forwarded-Host': X_FOWARD_HOST,
			},
		};

		api
			.get('/admin/unidade/json', options)
			.then(({ data, status }) => {
				if (status === 200) {
					//console.log(data);
					//if(data.unidades)
					setUnidades(data.unidades);
					setLoading(false);
				}
			})
			.catch((error) => {
				if (error.response.status === 401){
					window.location.reload(false);
					
				}
				//////console.log(err);
			});
	}

	function updateUnidades(unidade) {
		//////console.log(unidade);
		const u = [...unidades];
		let index = -1;

		for (let i = 0; i < u.length; i++) {
			if (u[i].id === unidade.id) {
				index = i;
			}
		}

		if (index !== -1) {
			//u.splice(index,1);
			//////console.log(u[index]);
			u[index] = unidade;
			//////console.log(u[index]);
		} else {
			u.push(unidade);
		}

		setUnidades([...u]);
	}

	async function getContas(params = {}) {
		try {
			setLoading(true);

		const { data, status } = await api.get('/admin/conta/json', params);
		if (status === 200) {
			setContas(data.contas);
			//self.setState({ contas: data.contas });
			setLoading(false);
		}
		} catch (error) {
			console.log(error)
			alert('Error' + error);
			if (error.response.status === 401) {
				window.location.reload();
			}
		}
		//var self = this;
		
	}

	async function getCidades() {

		try {
			setLoading(true);
			const { data, status } = await api.get('/admin/cidade/json');
			if (status === 200) {
				//console.log(data);
				setCidades(data.cidades);
			}	
		} catch (error) {
			console.log(error)
			alert('Error' + error);
			if (error.response.status === 401) {
				window.location.reload();
			}
		}

		
	}

	const [cidades, setCidades] = useState([]);

	return (
		<div style={{paddingTop:30,paddingLeft:15}} className='row Unidade'>
			<div className='col-md-12 header-page p-3'>
				<h2 className='title'>
					Unidades
					<div className='d-inline-block ml-4'>
						<button
							className='btn btn-sm btn-success'
							onClick={() => {
								setUnidade();
								setModalVisibleNova(true);
							}}>
							Nova Unidade
						</button>
					</div>
				</h2>
				<UnidadeForm
					//ref={novaUnidadeModal}
					elementId='novaUnidadeForm'
					contas={contas}
					callback={updateUnidades}
					modalVisible={modalVisibleNova}
					setModalVisible={setModalVisibleNova}
					cidades={cidades}
				/>
			</div>
			<div className='col-md-12'>
				<div className='card border-0 mt-4'>
					<div className='card-body'>
						<table className='table'>
							<thead>
								<tr>
									<th></th>
									<th>Nome</th>
									<th>Descrição</th>
									<th>Conta</th>
									<th></th>
								</tr>
							</thead>
							{loading ? (
								<tbody>
									<tr>
										<td className='text-center'>
											<div className='Skeleton'></div>
										</td>
										<td>
											{' '}
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
									</tr>
									<tr>
										<td className='text-center'>
											<div className='Skeleton'></div>
										</td>
										<td>
											{' '}
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
									</tr>
									<tr>
										<td className='text-center'>
											<div className='Skeleton'></div>
										</td>
										<td>
											{' '}
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
									</tr>
									<tr>
										<td className='text-center'>
											<div className='Skeleton'></div>
										</td>
										<td>
											{' '}
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
										<td>
											<div className='Skeleton'></div>
										</td>
									</tr>
								</tbody>
							) : (
								<tbody>
									{unidades.map((unidade) => (
										<UnidadeContainer
											unidade={unidade}
											contas={contas}
											updateUnidades={updateUnidades}
											cidades={cidades}
										/>
									))}
								</tbody>
							)}
						</table>
					</div>
				</div>
			</div>
		</div>
	);
}

function UnidadeContainer(props) {
	const { unidade, contas, updateUnidades, cidades } = props;

	const [modalVisibleEdit, setModalVisibleEdit] = useState(false);

	return (
		<tr key={unidade.id}>
			<UnidadeForm
				//key={'form' + unidade.id}
				elementId={'form' + unidade.id}
				item={unidade}
				contas={contas}
				callback={updateUnidades}
				modalVisible={modalVisibleEdit}
				setModalVisible={setModalVisibleEdit}
				cidades={cidades}
			/>
			<td className='text-center'>
				<span
					style={{ fontSize: '1.2em' }}
					// eslint-disable-next-line eqeqeq
					className={unidade.status == '1' ? 'text-success' : 'text-danger'}
					// eslint-disable-next-line eqeqeq
					title={unidade.status == '1' ? 'Ativa' : 'Desativada'}>
					&#x029BF;
				</span>
			</td>
			<td>{unidade.nome}</td>
			<td>{unidade.descricao}</td>
			<td>
				{unidade.conta.nome}
				<div className='font-weight-bold'>&#35;{unidade.conta.codigo}</div>
			</td>
			<td>
				<div className='float-right'>
					<button
						onClick={() => {
							//setUnidade(unidade);
							setModalVisibleEdit(true);
						}}
						className='btn btn-sm btn-primary mr-1'
						data-toggle='modal'
						data-target={'#form' + unidade.id}>
						Editar
					</button>
				</div>
			</td>
		</tr>
	);
}

export default Unidade;
